import { useEffect } from 'react';
export function useToolKeyboardShortcuts(params) {
    // Escape key handling for path extend mode
    useEffect(() => {
        if (!params.pathExtending)
            return;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                params.pathStopExtending();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [params.pathExtending, params.pathStopExtending]);
    // Keyboard handling for polygon vertex delete confirmation
    useEffect(() => {
        if (!params.polygonDeleteVertexPrompt)
            return;
        const handleKeyDown = (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                params.polygonConfirmDeleteVertex();
            }
            else if (e.key === 'Escape') {
                e.preventDefault();
                params.polygonCancelDeleteVertex();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [params.polygonDeleteVertexPrompt, params.polygonConfirmDeleteVertex, params.polygonCancelDeleteVertex]);
    // Escape key handler for dismissing spider pickers
    useEffect(() => {
        const hasActiveSpider = params.activeSpider || params.overlappingPolygons;
        if (!hasActiveSpider)
            return;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                e.preventDefault();
                if (params.activeSpider) {
                    params.dismissSpider();
                }
                if (params.overlappingPolygons) {
                    params.dismissOverlapPicker();
                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [params.activeSpider, params.dismissSpider, params.overlappingPolygons, params.dismissOverlapPicker]);
}
